import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

interface Vars {
  draftId: string;
  label: "A" | "B" | "C";
}

export const usePromoteAlternative = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ draftId, label }: Vars) => api.drafts.promoteAlternative(draftId, label),
    onSuccess: async (_data, { draftId }) => {
      await qc.refetchQueries({ queryKey: ["draft", draftId] });
    },
  });
};
